import { c as _c } from "react/compiler-runtime";
import { Box, SimpleGrid, useDisclosure } from '@chakra-ui/react';
import { SignupPaywall } from '@src/components/sco/Account/SignupPaywall';
import { ProPricingBlock } from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/blocks/ProPricingBlock';
import { GenericBlock } from '@src/components/sco/LayoutBlocks/GenericBlock';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const PricingBlock = () => {
  const $ = _c(8);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  useDisclosure();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maxWidth: "1420px"
    };
    t1 = {
      children: "Plan Options"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([1, 1, 1, 2]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box><SignupPaywall hideCouponCode={true} hideOptionBar={true} hideTermSelector={true} hideTitle={true} productAndTermIds={[["scom-accelerator-advisor-investor-matching", "month"]]} stackProps={{
        paddingY: 0
      }} productCardProps={{
        containerProps: {
          background: "colorPalette.container"
        },
        paymentPath: "/investors/matching/payment"
      }} productCardPropsByProductAndTermId={{
        "scom-accelerator-advisor-investor-matching-month": {
          containerProps: {
            paddingY: 6,
            maxWidth: "full"
          }
        }
      }} /></Box>;
    t4 = <ProPricingBlock />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <GenericBlock innerBoxProps={t0} headingProps={t1}><SimpleGrid columns={t2} gap={6} marginX="auto">{t3}{t4}</SimpleGrid></GenericBlock>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};